// import React from 'react'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import Color  from 'constants/colors'

export const Wrapper = styled.div`
	padding: 5px 100px;
	background-color: whitesmoke;
	border-radius: 1px;
  @media screen and (max-width: 767px) {
		padding: 10px;
		background-color: none;
  }
  @media print {
    display: none;
  }
`;

export const MyNotesContainer = styled.div`
	border: 3px solid black;
	border-radius: 3px;
	min-height: 65px;
	box-sizing: border-box;
	padding: 10px 20px;
	background-color: white;
`;

export const Notes = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-height: 65px;
	font-family: ${props=>props.theme.fonts.h5};
	font-weight: bold;
	font-size: 14px;
	color: black;
`;

export const FillInTheBlank = styled.input`
	display: inline;
	font-family: ${props=>props.theme.fonts.h5};
	font-weight: bold;
	font-size: 14px;
	background-color: transparent;
	color: ${Color('purple')};
	outline: none;
	border: none;
	border-bottom: 2px solid black;
	-webkit-appearance: none;
	margin-left: 4px;
	margin-right: 4px;

  &:focus {
    transition: background-color 200ms ease-in;
    background-color: rgba(0,0,0,0.05);
  }
`;
export const ContainerLabel = styled.h3`
	text-align: left;
	color: #999;
	margin-top: 0;
	margin-bottom: 5px;
`;

export const OptionLabel = styled.h3`
	font-weight: normal;
	margin-left: 20px;
	margin-top: 5px;
	display: inline-block;
	cursor: pointer;
`;

export const Options = styled.div`
	text-align: right;
`;

export const SpreadApart = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const MoreInfo = styled(Link)`
	font-family: ${props=>props.theme.fonts.h3};
	text-transform: uppercase;
	font-size: 14px;
	padding-top: 5px;
	text-decoration: none;
	color: #333;
`;



// WEBPACK FOOTER //
// ./src/components/interactive/votePref/styles.js